import './box.scss';
import React, {useState} from "react";
import parse from 'html-react-parser';
import {CategoryItem} from "../categories/item.js";
import {getCategoryById} from "../categories/categories_mapping.js";
import {useStateContext} from "../../helpers/state-context.js";
import {ReactComponent as UpIcon} from "../../assets/chevron-up.svg";
import {ReactComponent as DownIcon} from "../../assets/chevron_down.svg";

const centerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const CountryBox = function (props) {
    const [state] = useStateContext(['renderSize']);
    const [expanded, setExpanded] = useState(props.expanded)
    const viewSize = ['xs', 'sm'].includes(state.renderSize) ? 'small' : 'full';
    const {type, data, caption, style} = props;

    const parseData = (data) => {
        // Add target blank for every href
        // Regex finds 'a' html tag and adds target='_blank' at the end of the attributes.
        let replacedHyperLinks = data.replace(/(<a[^>]*)(>)/g, "$1 target='_blank' $2")

        return parse(replacedHyperLinks)
    }

    const renderImage = ()=>{
        return <>
            <div style={{maxWidth: 350}}>
                <img style={{maxWidth: '100%', maxHeight: 'auto'}} alt={data} src={data}/>
            </div>
            <em>{parseData(caption)}</em>
        </>
    };

    const renderCategories=()=>{
        return <div className={'category-container'}>
            {data.map((categoryId)=>{
                const category = getCategoryById(categoryId)
                if(category){
                    const iconStyle = {
                        border: `4px solid ${category.color}`,
                        width: (viewSize === 'small') ? 50 : 70,
                        height: (viewSize === 'small') ? 50 : 70,
                        margin: (viewSize === 'small') ? '10px' : '0 15px',
                    };
                    return <React.Fragment key={categoryId}>
                        <CategoryItem category={category} isCategoryActive={true} iconStyle={iconStyle} categoryStyle={{cursor: 'default'}}/>
                    </React.Fragment>
                }
                return null;
            })}
        </div>
    }

    const renderHorizontalList = () =>{
        return <div style={{display: 'flex',flexWrap: 'wrap', justifyContent:'flex-start'}}>
            {data.map((item, key)=>{
                return <span key={key}
                        style={{
                            flex: (viewSize === 'small') ? '0 100%' : '0 48%',
                            margin: (viewSize === 'small')? 
                                '10px 0px':
                                (key%2===0? '10px 2% 10px 0px': '10px 0px 10px 2%')
                        }}
                >
                    {parseData(item.title_url)}
                    <span style={{display: 'block', margin: '10px 0'}}>{item.date_of_the_news_item}</span>
                </span>
            })}
        </div>
    }

    const renderLastUpdated = (data) => (
        <div style={{maxWidth: 350}}>
            <span style={{fontSize: '90%'}}>Last updated on:</span><br/>
            <em>{data}</em>
        </div>
    );

    const showBox = ()=>{
        switch(type){
            case "image":
                return renderImage();
            case "categories":
                return renderCategories();
            case "horizontal_list":
                return renderHorizontalList();
            case 'last-updated':
                return renderLastUpdated(data);
            default:
                return parseData(data)
        }
    }

    const toggle = () => {
        if(props.expandable){
            setExpanded((prevS) => !prevS);
            props.onToggle(!props.expanded);
        }
    };

    const iconStyle = {width: 20, height: 20, fill: 'grey'};
    const toggleText = (expanded) ? 'Hide' : 'Show';
    const toggleIcon = (expanded) ? <UpIcon style={iconStyle}/> : <DownIcon style={iconStyle}/>;

    if(props.children || (data &&  data.length > 0)){
        const boxType = `country-box country-box${(type) ? `-${type}` : ''}`;
        return <div className={boxType} style={{padding: expanded ? '30px': '0 30px', ...style}}>
            <div style={{cursor: (props.expandable) ? "pointer" : 'default', ...centerStyle}} onClick={toggle}>
                {props.title ? <h4 style={{fontWeight: 'bold'}}>{props.title}</h4> : null}
                {(props.expandable) ?
                    <h4 style={centerStyle} >
                        {toggleText} {toggleIcon}
                    </h4>:
                null}
            </div>
            {(expanded) ?
                (props.children) ? props.children : showBox() :
            null}
        </div>
    }
    return null;
};

CountryBox.defaultProps={
    expanded: true,
    type: ''
}

export {CountryBox}